exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".file-download-grp{display:inline-block;text-align:left;padding:4px;width:100%;height:100%;overflow:hidden}.file-download-grp .file-download-area{height:calc(100% - 32px);height:-moz-calc(100% - 32px);overflow-y:auto}.file-download-grp .file-download{border-bottom-width:0}.file-download-grp .file-download .loadinfo{margin-top:4px}.file-download-grp .file-download.last{border-bottom-width:1px}.file-download-grp .summary{height:30px;line-height:18px;padding-top:8px}.file-download-grp .summary .total{color:navy}.file-download-grp .summary .done{color:#090}.file-download-grp .summary .fail{color:#e4393c}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-15aa309c","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/compo/ctrl/FileDownloadGrp.vue
// module id = 1629
// module chunks = 1